import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, Observable, tap } from 'rxjs';

import {
  HttpRequestLog,
  NetworkActivityService,
} from '../services/network-activity/network-activity.service';

function headersToRecord(headers: {
  keys: () => string[];
  get: (key: string) => string | null;
}): Record<string, string> {
  return headers.keys().reduce((acc, key) => {
    const value = headers.get(key);
    if (value) acc[key] = value;
    return acc;
  }, {} as Record<string, string>);
}

@Injectable()
export class NetworkActivityInterceptor implements HttpInterceptor {
  constructor(private networkActivityService: NetworkActivityService) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const startTime = Date.now();
    const id = `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`;
    const requestHeaders = headersToRecord(req.headers);

    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          let responseBodyCopy: unknown = null;
          if (event.body != null) {
            try {
              responseBodyCopy = JSON.parse(JSON.stringify(event.body));
            } catch {
              responseBodyCopy = String(event.body);
            }
          }
          const log: HttpRequestLog = {
            id,
            url: req.url,
            method: req.method,
            timestamp: startTime,
            requestHeaders,
            requestBody: req.body,
            responseStatus: event.status,
            responseHeaders: headersToRecord(event.headers),
            responseBody: responseBodyCopy,
            duration: Date.now() - startTime,
          };
          this.networkActivityService.addRequest(log);
        }
      }),
      catchError((error: HttpErrorResponse) => {
        const log: HttpRequestLog = {
          id,
          url: req.url,
          method: req.method,
          timestamp: startTime,
          requestHeaders,
          requestBody: req.body,
          responseStatus: error.status ?? 0,
          responseHeaders: error.headers ? headersToRecord(error.headers) : {},
          responseBody: (() => {
            if (error.error == null) return null;
            if (typeof error.error === 'object') {
              try {
                return JSON.parse(JSON.stringify(error.error));
              } catch {
                return String(error.error);
              }
            }
            return String(error.error);
          })(),
          duration: Date.now() - startTime,
        };
        this.networkActivityService.addRequest(log);
        throw error;
      })
    );
  }
}
